module.exports = __webpack_public_path__ + "static/media/5.7ac5078a.jpg";